import React from "react"

const CourseTitle = ({ children }) => <h1 className="font-extrabold text-4xl sm:text-5xl leading-tight">{children}</h1>

export default CourseTitle
